export const WHATSAPP_NUMBER = "5511940272123";
export const WHATSAPP_MESSAGE = encodeURIComponent(
  "Olá, quero falar com a Buzas"
);
export const WHATSAPP_URL = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${WHATSAPP_MESSAGE}`;

export const CONTACT_EMAIL = "comercial@buzas.com.br";
export const LGPD_EMAIL = "lgpd@buzas.com.br";
export const LINKEDIN_URL =
  "https://www.linkedin.com/company/buzas-industria-e-comercio-ltda/";
export const INSTAGRAM_URL = "https://www.instagram.com/buzas_laser_service/";

export const PRIVACY_POLICY_PATH = "/politica-de-privacidade";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_efc60e4f-8a40-4967-a62c-db7325c28771/artifacts/n9hhv7gl_logo01.png";

export const LOGO_WHITE_URL =
  "https://customer-assets.emergentagent.com/job_pecas-aviacao/artifacts/eekj2zvo_%5BBuzas%5D_Logo_02%20%281%29.png";

export const HERO_IMAGE = "/hero-aeroviario.png";

export const HANGAR_IMAGE = "/hero-aeroviario.png";

export const LASER_IMAGE = "/transition-aeroviario.png";

export const GEOMETRIC_TEXTURE =
  "https://static.prod-images.emergentagent.com/jobs/efc60e4f-8a40-4967-a62c-db7325c28771/images/60b28912cd34f3a7d258553de2b85b2bb84d2899abcc21ae06428eae9baeed09.png";
